import React from "react";

import { Container, Button } from "reactstrap";
import Panel from "shared/react_components/Panel";
import StickyFooter from "shared/react_components/StickyFooter";
import PropTypes from "prop-types";

export default class Wizard extends React.Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
    onBack: PropTypes.func.isRequired,
    children: PropTypes.node.isRequired
  };

  render() {
    const { title, children } = this.props;

    return (
      <Container>
        <Panel
          title={title}
          className="panel-wizard"
        >
          {children}
        </Panel>
        <StickyFooter>
          <Button color="secondary" onClick={() => this.props.onBack()}>
            Back
          </Button>
        </StickyFooter>
      </Container>
    );
  }
}
